import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { FileProvider } from '../file.provider';
import { StoredFile } from '../../model/file';
import { FileUploadDialog } from '../file.upload/file.upload.dialog';
import { MatDialog } from '@angular/material';
import { UIService } from '../../ui.service';
import { I18N } from 'ess-plugin-base';

@Component({
    selector: 'file-linker',
    templateUrl: './file.linker.html',
    styleUrls: ['./file.linker.scss'],
    // encapsulation: ViewEncapsulation.Emulated
})
export class FileLinker implements OnInit, OnChanges {

    /*Nobel 2025-08-12*/
    @Input('accept')
    accept: string;

    @Input('folder_id')
    folder_id: number;

    @Input('path')
    path: string = '';

    @Input('resource')
    resource: string = '';

    @Input('files')
    files: Map<string, Set<StoredFile>> = new Map();

    @Input('titleText')
    titleText: string;

    @Input('showFiles')
    showFiles: boolean;

    @Input('maxNameLength')
    maxNameLength: number = 40    

    @Input('showButtons')
    showButtons: boolean;

    @Input('canAdd')
    canAdd: boolean;

    @Input('canDelete')
    canDelete: boolean;

    @Output('onOpen')
    onOpen: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('onEdit')
    onEdit: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('onUpload')
    onUpload: EventEmitter<any> = new EventEmitter<any>();

    @Output('onDownload')
    onDownload: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    // showing: boolean = null;

    constructor(private fileProvider: FileProvider, private dialog: MatDialog, 
            public i18n: I18N, private ui: UIService) {
                //debugger;
            }

    ngOnInit() {
        //debugger;
        if (this.showFiles) this.reload();
    }

    ngOnChanges() {
        debugger;
        if (this.showFiles) this.reload();
    }

    // select(file: StoredFile) {
    //     this.onSelect.emit(file);

    //     this.showing = (this.showing)? null : true;
    // }

    reload() {
        if (!this.resource || !this.resource.length) return;
        // console.log(this.path + this.resource);

        // let fnames: Set<string> = new Set<string>();
        let latest: StoredFile = null;

        // this.fileProvider.exploreFiles(this.folder_idthis.root + this.path, this.resource)
        this.fileProvider.getFiles(this.folder_id, this.resource, this.path)
        .then(data => {
            
            // this.folders = [];
            this.files = new Map();
            let s = this.files.get(this.path) || new Set();
            this.files.set(this.path, s);
            for(let f of data) {
                // if (f.isDirectory()) {
                //     this.folders.push(f);
                // } else {
                    if (latest && latest.filename == f.filename) {
                        latest.versions.push(f);
                    } else {
                        //fnames.add(f.filename);
                        latest = f;
                        debugger;
                        s.add(f);
                    }
                // }
            }
        });
    }

    upload(files: File[]) {
        /*Nobel 2025-08-12*/
        debugger;
        const dialogRef = this.dialog.open(FileUploadDialog, {
            width: '50%', height: '50%', hasBackdrop: true, disableClose: true,
            data: {path: this.path, folder: this.folder_id, resource: this.resource, titleText: this.titleText, files: this.files.get(this.path), accept: this.accept}
        });
      
        dialogRef.afterClosed().
        toPromise()
        .then(result => {
            // if (!result || !result.length || result == this.path) {
            //     return;
            // }
            // if (this.path.startsWith('/')) {
            //     this.path = this.path.substring(1);
            // }

            this.reload();
            this.onUpload.emit(result);
            // fileProvider.newFolder(result, this.resource)
            // .then(ok => {
            //     this.path = result;
            //     this.folders = [];
            //     this.files = [];
            // })
        })
        .catch(err => console.log(err));
    }

    download(file: StoredFile) {
        // console.log(file.filename);
        this.fileProvider.download(file)
        .then(ok => {
            if (ok) this.onDownload.emit(file);
        });
    }

    open(file: StoredFile) {
        if (file && file.guid && this.onOpen.observers.length) {
            this.onOpen.emit(file);
        }
    }

    edit(file: StoredFile) {
        if (file && file.guid && this.onEdit.observers.length) {
            this.onEdit.emit(file);
        }
    }

    async deleteFile(file: StoredFile) {
        let message = this.i18n.get('file_confirm_delete', 'Delete this file?');
        let yes = this.i18n.get('delete', 'Delete');
        let no = this.i18n.get('cancel', 'Cancel');
        let ok = await this.ui.confirm(message, null, yes, no);

        if (ok) {
            this.fileProvider.delete('file', file.guid, file.filename, this.resource, this.folder_id)
            .then(ok => {
                let s: Set<StoredFile> | undefined = this.files.get(this.path);
                if (s != null) {
                    s.delete(file);
                }
            })
        }
    }

    onFilesAdded() {}

    // edit(file: StoredFile) {
    //     console.log("Clicked", file);
    //     if (file && file.guid && this.onEdit.observers.length) {
    //         this.onEdit.emit(file);
    //     }
    // }

    getExtension(file: StoredFile): string {
        return this.fileProvider.getExtension(file);
        // if (file && file.filename && file.size > 0) {
        //     return file.filename.slice(file.filename.lastIndexOf('.') + 1);
        // }
        // if (file) {
        //     return 'folder';
        // }
        // return null;
    }
}